

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

//warning!! this file is also shared and used inside demo page, see uniwizard-lib.js
//be careful when changing
import { getTranslator } from '../js/i18n';
import tools from '../js/tools';
import MouseHandler from './mouse';
import utils from './utils';

const t = getTranslator();

export function SignatureForm() {
}
SignatureForm.prototype = {
    img: null,
    canvas: null,
    ctx: null,
    bitmapurl: null,
    cb: null,
    handler: null,
    wndData: null,
    cleanupEventListeners: null,
    prepare(cb) {
        cb();
    },
    connect(formData, cb) {
        const self = this;
        if(formData.invisibleSignature) {
            setTimeout(() => cb(null, {}), 1);
            return;
        }
        self.img = formData.img;
        self.canvas = formData.canvas;
        const signatureContainerBox = formData.signatureContainerBox;
        self.ctx = self.canvas.getContext('2d');
        self.bitmapurl = formData.bitmapurl;
        self.cb = cb;
        self.cleanupEventListeners = [];

        self.handler = new MouseHandler(self, true);
        self.handler.init();
        try {
            self.handler.connect();
            self.handler.clearScreen();

            function handleKeyDown(e) {
                const key = e.key || e.keyCode;
                if(key === 'Escape' || key === 'Esc' || key === 27) {
                    self.btnCancel_Click();
                } else if(key === 'Enter' || key === 13) {
                    self.btnOk_Click();
                }
            }
            signatureContainerBox.addEventListener('keydown', handleKeyDown);
            self.cleanupEventListeners.push(function() {
                signatureContainerBox.removeEventListener('keydown', handleKeyDown);
            });
        } catch(ex) {
            self.closeAll();
            cb(ex);
        }
    },
    createModalWindow(isHorizontal) {
        const _dr = this;
        if(_dr.wndData)
            return _dr.wndData;

        const buttons = new utils.Buttons();
        buttons.add({
            text: t('common.ok'),
            image: 'ok',
            click() {
                _dr.btnOk_Click();
            },
        });
        buttons.add({
            text: t('common.cancel'),
            image: 'cancel',
            click() {
                _dr.btnCancel_Click();
            },
        });

        const width = _dr.canvas.clientWidth;
        const height = _dr.canvas.clientHeight;
        const btns = buttons.construct(width, height, isHorizontal);

        const imgparams = {
            width,
            height,
            isHorizontal,
            buttons: btns,
        };
        const imageUrl = new utils.ImageUrl(_dr.bitmapurl, imgparams);
        _dr.wndData = {
            btns,
            width,
            height,
            ctx: _dr.ctx,
            imageUrl,
            bioDeviceMask: utils.FILTER_POINTER_ALL_INTERNAL,
        };

        const imgurl = imageUrl.construct({ format: 'png', type: 'image', transparent: true });
        _dr.img.src = imgurl;
        return _dr.wndData;
    },

    clearImage() {
        const ctx = this.ctx;
        const width = this.wndData.width;
        const height = this.wndData.height;
        ctx.clearRect(0, 0, width, height);
    },

    selectDevice(handler, device) {
    },
    btnOk_Click() {
        try {
            this.finishSignature({});
        } catch(ex) {
            tools.scripterr(ex);
        }
    },
    btnCancel_Click() {
        this.finishSignature(null);
    },
    closeAll() {
        try { this.handler.close(); } catch(ex) { /**/ }
        if(this.cleanupEventListeners) {
            this.cleanupEventListeners.forEach((listener) => {
                try { listener(); } catch(e) { /**/ }
            });
            this.cleanupEventListeners = [];
        }
    },
    finishSignature(signData) {
        this.closeAll();
        this.cb(null, signData);
    },
};
